import styles from "./BlackButton.module.css";

const BlackButton = ({ text }) => {
  return (
    <div className={styles.blackBtn}>
      <button className={styles.button}>{text}</button>
    </div>
  );
};
export default BlackButton;
